var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.68 17.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "layers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6,37.32l-9.7-5.89h7.91l-10.37-6.3H17.7l8,4.89H15.92l8.87,5.39H15.92l12,7.3H46.6l-8.87-5.39ZM19.49,31H27.4l.67.41H35L43,36.32h-7l-1.38-.84-.12-.07H26.71ZM43,41.71H28.21l-8.72-5.3h6.94l1.5.91H35.8Z",
    transform: "translate(-15.92 -25.13)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.a15058e710057ccd715e2ebd3623ee29.svg";
export { ForwardRef as ReactComponent };